import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { PROFFIT_SEARCH_SEARCH_BG_IMAGE_URL } from '../../../../define/consts/assets';
import { propFunc, propStr, propChildren, propShape, } from '../../../../helpers/custom-prop-types';
import SearchSimpleIcon from '../../../Icon/Svg/SearchSimpleIcon';
import SubmitButton from '../../Button/SubmitButton';
const SlideSearchSearchForm = (props) => {
    const { className, defaultValue, inputRef, onSubmit, placeholder, titleComponent, } = props;
    const style = useMemo(() => ({
        backgroundImage: `url("${PROFFIT_SEARCH_SEARCH_BG_IMAGE_URL}")`,
    }), []);
    return (_jsx("form", Object.assign({ className: clsx('slide_search_search_form', className), onSubmit: onSubmit, style: style }, { children: _jsx("div", Object.assign({ className: 'search_area' }, { children: _jsxs("div", Object.assign({ className: 'search_area_inner' }, { children: [titleComponent, _jsx("div", Object.assign({ className: 'search_area_form' }, { children: _jsxs("div", Object.assign({ className: 'search_area_form_inner' }, { children: [_jsx("input", { autoComplete: 'off', className: 'search_area_input', defaultValue: defaultValue, name: 'keyword', placeholder: placeholder, ref: inputRef, type: 'search' }), _jsxs("div", Object.assign({ className: 'search_area_box' }, { children: [_jsx("input", { className: 'search_area_btn', type: 'submit', value: '検索' }), _jsx(SubmitButton, { buttonType: 'submit', className: 'search_area_btn', isDisabled: false, isLoading: false, text: _jsx(SearchSimpleIcon, {}) })] }))] })) }))] })) })) })));
};
SlideSearchSearchForm.propTypes = {
    className: propStr(),
    defaultValue: propStr().isRequired,
    inputRef: propShape().isRequired,
    onSubmit: propFunc().isRequired,
    placeholder: propStr(),
    titleComponent: propChildren(),
};
SlideSearchSearchForm.defaultProps = {
    className: '',
    placeholder: undefined,
    titleComponent: undefined,
};
export default SlideSearchSearchForm;
